import i18n from "@/config/i18n";
export const LANGS = {
  zh: "zh-CN",
  th: "th-TH",
  en: "en-US"
};
export const APP_TYPE_OPS = [
  { value: "0", label: "Android" },
  { value: "1", label: "IOS" }
];

export const APP_UPDATE_STATUS = [
  { value: "0", label: i18n.t("pendingActivation") },
  { value: "1", label: i18n.t("effective") },
  { value: "2", label: i18n.t("ineffective") }
];
